import vuex from "src/vuex"
import * as Cookies from "js-cookie";
import userPermission from "@/util/valueObjects/userPermission";

export default (to, from, next) => {
  let permissions = vuex.getters.getPermissions;
  for (let permission of permissions) {
    if (permission === userPermission.INTEGRA_MANAGER__SHIPPER_COMMERCIAL.value) {
      vuex.dispatch("redirectToOrder", Cookies.getJSON("token"));
      break;
    }
  }

  next();
};
